module.exports = __webpack_public_path__ + "static/media/glab-task-stream.c3b29f01.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/glab-task-stream.png
// module id = 410
// module chunks = 0